const ACTIVE_BUSINESS_KEY = 'haastia.activeBusinessId';

// Stored in localStorage so the active workspace outlives a closed tab, matching
// the lifetime of the auth token in utils/auth.js. Cleared by clearAuthStorage.
const canUseStorage = () => typeof window !== 'undefined' && Boolean(window.localStorage);

export const getStoredActiveBusinessId = () => {
  if (!canUseStorage()) return null;
  try {
    return window.localStorage.getItem(ACTIVE_BUSINESS_KEY) || null;
  } catch (_err) {
    return null;
  }
};

export const storeActiveBusinessId = (businessId) => {
  if (!canUseStorage()) return;
  try {
    if (businessId) {
      window.localStorage.setItem(ACTIVE_BUSINESS_KEY, businessId);
    } else {
      window.localStorage.removeItem(ACTIVE_BUSINESS_KEY);
    }
  } catch (_err) {
    // Local storage can be unavailable in privacy-restricted browsers.
  }
};

export const clearActiveBusinessId = () => storeActiveBusinessId(null);

export const normalizeBusinessList = (user) => (Array.isArray(user?.businesses) ? user.businesses : []);

export const resolveInitialActiveBusiness = (user) => {
  const businesses = normalizeBusinessList(user);
  if (businesses.length === 0) return null;
  if (businesses.length === 1) return businesses[0];

  const storedId = getStoredActiveBusinessId();
  return businesses.find((business) => business?._id === storedId) || user?.activeBusiness || businesses[0];
};

export const userHasBusiness = (user, businessId) =>
  normalizeBusinessList(user).some((business) => business?._id === businessId);
